import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/content/help_page_list',
    ADD: '/content/help_page_add',
    UPDATE: '/content/help_page_update',
    DELETE: '/content/help_page_del',
    TITLE_IS_EXIST: '/content/help_page_is_exist_title',
}

export async function helpPageList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function helpPageAdd(form) {
    return requestPost(api.ADD, form);
}

export async function helpPageUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function helpPageDelete(id) {
    return requestPost(api.DELETE, { id });
}

export async function helpPageTitleIsExist(title) {
    let params = {val: title};
    return requestGet(api.TITLE_IS_EXIST, params);
}

